import { useEffect, useRef } from "react";

const TYPING = ["INPUT", "TEXTAREA", "SELECT"];

export function useEscapeToClose(open: boolean, onClose: () => void) {
  const close = useRef(onClose);
  close.current = onClose;

  useEffect(() => {
    if (!open) return;
    const handle = (event: KeyboardEvent) => {
      if (event.key !== "Escape") return;
      if (document.querySelector('[role="dialog"], [role="alertdialog"]'))
        return;
      const target = event.target;
      if (
        target instanceof HTMLElement &&
        (target.isContentEditable || TYPING.includes(target.tagName))
      )
        target.blur();
      else close.current();
    };
    window.addEventListener("keydown", handle);
    return () => window.removeEventListener("keydown", handle);
  }, [open]);
}
